import React from 'react';
import { twJoin } from 'tailwind-merge';
import { DetailsTileHeadingProps } from './types/DetailsTileHeadingProps';

export default function DetailsTileHeading({
  heading,
  className,
  colon,
}: Readonly<DetailsTileHeadingProps>) {
  return (
    <h3 className={twJoin('text-xl font-bold sm:text-2xl lg:text-3xl', className)}>
      {heading}
      <span className="text-primary-100">{colon || ':'}</span>
    </h3>
  );
}
